import CustomerLogos from '@/domain/CustomerLogos';
import * as customers from '@/domain/customers';

export default function PartnersClientBrands() {
  return (
    <div className="flex justify-center py-10 bg-gradient-to-t from-gray-200 to-gray-100">
      <h3 className="sr-only">Socios</h3>
      <CustomerLogos
        customers={[
          customers.udla,
          customers.iess,
          customers.soyHincha,
          customers.nestle,
          customers.soltein,
          customers.modernaAlimentos,
        ]}
      />
    </div>
  );
}
